import dynamic from "next/dynamic";
const TagsByProductHomepageFirstFoldComponent = dynamic(()=>import("./tags-by-product-homepage-first-fold-component"));
import TagsByProductHomepageFirstFoldConfig from "./tags-by-product-homepage-first-fold-config";
import TagsByProductHomepageFirstFoldAdvancedConfig from "./tags-by-product-homepage-first-fold-advanced-config";
export default {
    TagsByProductHomepageFirstFoldComponent,
    TagsByProductHomepageFirstFoldConfig,
    TagsByProductHomepageFirstFoldAdvancedConfig
};
